import React from 'react';


class ShopList extends React.Component{


  constructor(props){
   super(props)
   this.state={
       name:""
   }
  }


  render(){

    return(
        <div>这是商品列表组件</div>
    )
    
  }
}

export default ShopList;


// WEBPACK FOOTER //
// ./src/components/Shop/ShopList.js